import m from "../../geodata/es2015/continentsUltra";
window.am4geodata_continentsUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsUltra.js
// module id = null
// module chunks = 